<div *ngIf="!processing">
  <span class="content-text" *ngIf="auctionStatus && !(['CLOSED', 'SETTLED'].includes(auctionStatus))">The auction is not yet closed. This tab will populate with information when the auction is in the closed or settled stage.</span>

  <div class="container-fluid" *ngIf="auctionReport && auctionStatus && (auctionStatus === 'CLOSED' || auctionStatus === 'SETTLED')">

    <h6 class="lot-header mt-3">Sale Lots</h6>
    <div class="gross-sale-total mb-3">Gross Sale Total: {{ getFormattedGrossSaleTotal() }}</div>

    <app-auction-report-sold-lot-group [soldLineItems]="filterByStatus(auctionReport.lineItems, 'SOLD')" (messageEvent)="receiveMessage($event)"></app-auction-report-sold-lot-group>

    <h6 class="lot-header mt-4">No Sale Lots</h6>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="table-header-text-link" style="width: 4rem;">LOT #</th>
            <th scope="col" class="table-header-text-link" style="width: 18.75rem;">NAME</th>
            <th scope="col" class="table-header-text-link" style="width: 10rem;">FINAL BID</th>
            <th scope="col" class="table-header-text-link" style="width: 12rem;">WINNING BIDDER</th>
            <th scope="col" class="table-header-text-link">QTY</th>
            <th scope="col" class="table-header-text-link">FINAL PRICE</th>
            <th scope="col" class="table-header-text-link">SALE/NO SALE</th>
          </tr>
        </thead>
        <tbody>
            <tr app-auction-report-lot-detail *ngFor="let item of filterByStatus(auctionReport.lineItems, 'UNSOLD')" [lot]="item" [auctionStatus]="auctionStatus" (messageEvent)="receiveMessage($event)"></tr>
        </tbody>
      </table>
    </div>
  </div>
</div>